import React from 'react';

import {Heading} from '@albert-io/atomic';
import {ClassDetailHeader} from '../ClassDetail/ClassDetailHeader';

import {getNavScope} from '../Sidemenu/teacherNavScope';

// Static cross-class header above every "All Classwork" page; the page names its own section.
const AllClassworkHeader = () => (
  <header className='flex shrink-0 items-center border-b border-primary p-x4'>
    <Heading as='h1' className='m-x0 truncate' size='m'>
      All Classwork
    </Heading>
  </header>
);

interface Props {
  pathname: string;
}

/**
 * The teacher dashboard's page header, chosen from the current nav scope: the
 * colored class banner inside a class, else the static "All Classwork" header.
 * New scopes/headers slot into the switch below as the dashboard grows.
 */
export const DashboardHeader = ({pathname}: Props) => {
  const scope = getNavScope(pathname);

  if (scope.kind === 'class') {
    // Keyed so a class switch resets the banner instead of showing the previous class's name/color.
    return <ClassDetailHeader classroomId={scope.classId} key={scope.classId} />;
  }

  return <AllClassworkHeader />;
};
